var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-view"},[_c('div',{staticClass:"page-header"},[_c('span',{staticClass:"header-text"},[_vm._v("组织架构管理")])]),_c('div',{staticClass:"framework-view"})])
}]

export { render, staticRenderFns }